import { Ison } from '../components/characters/codegen/Ison.js';
import { Oligon } from '../components/characters/codegen/Oligon.js';
import { OligonKentimaMiddle } from '../components/characters/codegen/OligonKentimaMiddle.js';
import { OligonKentimaBelow } from '../components/characters/codegen/OligonKentimaBelow.js';
import { OligonKentimaAbove } from '../components/characters/codegen/OligonKentimaAbove.js';
import { OligonYpsiliRight } from '../components/characters/codegen/OligonYpsiliRight.js';
import { OligonYpsiliLeft } from '../components/characters/codegen/OligonYpsiliLeft.js';
import { OligonKentimaYpsiliRight } from '../components/characters/codegen/OligonKentimaYpsiliRight.js';
import { OligonKentimaYpsiliMiddle } from '../components/characters/codegen/OligonKentimaYpsiliMiddle.js';
import { OligonDoubleYpsili } from '../components/characters/codegen/OligonDoubleYpsili.js';
import { OligonKentimataDoubleYpsili } from '../components/characters/codegen/OligonKentimataDoubleYpsili.js';
import { OligonKentimaDoubleYpsiliRight } from '../components/characters/codegen/OligonKentimaDoubleYpsiliRight.js';
import { OligonKentimaDoubleYpsiliLeft } from '../components/characters/codegen/OligonKentimaDoubleYpsiliLeft.js';
import { OligonTripleYpsili } from '../components/characters/codegen/OligonTripleYpsili.js';
import { OligonKentimataTripleYpsili } from '../components/characters/codegen/OligonKentimataTripleYpsili.js';
import { OligonKentimaTripleYpsili } from '../components/characters/codegen/OligonKentimaTripleYpsili.js';
import { OligonIson } from '../components/characters/codegen/OligonIson.js';
import { OligonApostrofos } from '../components/characters/codegen/OligonApostrofos.js';
import { OligonYporroi } from '../components/characters/codegen/OligonYporroi.js';
import { OligonElafron } from '../components/characters/codegen/OligonElafron.js';
import { OligonElafronApostrofos } from '../components/characters/codegen/OligonElafronApostrofos.js';
import { OligonChamili } from '../components/characters/codegen/OligonChamili.js';
import { IsonApostrofos } from '../components/characters/codegen/IsonApostrofos.js';
import { Apostrofos } from '../components/characters/codegen/Apostrofos.js';
import { ApostrofosSyndesmos } from '../components/characters/codegen/ApostrofosSyndesmos.js';
import { Yporroi } from '../components/characters/codegen/Yporroi.js';
import { Elafron } from '../components/characters/codegen/Elafron.js';
import { RunningElafron } from '../components/characters/RunningElafron.js';
import { ElafronApostrofos } from '../components/characters/codegen/ElafronApostrofos.js';
import { Chamili } from '../components/characters/codegen/Chamili.js';
import { ChamiliApostrofos } from '../components/characters/codegen/ChamiliApostrofos.js';
import { ChamiliElafron } from '../components/characters/codegen/ChamiliElafron.js';
import { ChamiliElafronApostrofos } from '../components/characters/codegen/ChamiliElafronApostrofos.js';
import { DoubleChamili } from '../components/characters/codegen/DoubleChamili.js';
import { DoubleChamiliApostrofos } from '../components/characters/codegen/DoubleChamiliApostrofos.js';
import { DoubleChamiliElafron } from '../components/characters/codegen/DoubleChamiliElafron.js';
import { DoubleChamiliElafronApostrofos } from '../components/characters/codegen/DoubleChamiliElafronApostrofos.js';
import { TripleChamili } from '../components/characters/codegen/TripleChamili.js';
import { PetastiIson } from '../components/characters/codegen/PetastiIson.js';
import { Petasti } from '../components/characters/codegen/Petasti.js';
import { PetastiOligon } from '../components/characters/codegen/PetastiOligon.js';
import { PetastiKentima } from '../components/characters/codegen/PetastiKentima.js';
import { PetastiYpsiliRight } from '../components/characters/codegen/PetastiYpsiliRight.js';
import { PetastiYpsiliLeft } from '../components/characters/codegen/PetastiYpsiliLeft.js';
import { PetastiKentimaYpsiliRight } from '../components/characters/codegen/PetastiKentimaYpsiliRight.js';
import { PetastiKentimaYpsiliMiddle } from '../components/characters/codegen/PetastiKentimaYpsiliMiddle.js';
import { PetastiDoubleYpsili } from '../components/characters/codegen/PetastiDoubleYpsili.js';
import { PetastiKentimataDoubleYpsili } from '../components/characters/codegen/PetastiKentimataDoubleYpsili.js';
import { PetastiKentimaDoubleYpsiliRight } from '../components/characters/codegen/PetastiKentimaDoubleYpsiliRight.js';
import { PetastiKentimaDoubleYpsiliLeft } from '../components/characters/codegen/PetastiKentimaDoubleYpsiliLeft.js';
import { PetastiTripleYpsili } from '../components/characters/codegen/PetastiTripleYpsili.js';
import { PetastiKentimataTripleYpsili } from '../components/characters/codegen/PetastiKentimataTripleYpsili.js';
import { PetastiKentimaTripleYpsili } from '../components/characters/codegen/PetastiKentimaTripleYpsili.js';
import { PetastiApostrofos } from '../components/characters/codegen/PetastiApostrofos.js';
import { PetastiYporroi } from '../components/characters/codegen/PetastiYporroi.js';
import { PetastiElafron } from '../components/characters/codegen/PetastiElafron.js';
import { PetastiRunningElafron } from '../components/characters/PetastiRunningElafron.js';
import { PetastiElafronApostrofos } from '../components/characters/codegen/PetastiElafronApostrofos.js';
import { PetastiChamili } from '../components/characters/codegen/PetastiChamili.js';
import { PetastiChamiliApostrofos } from '../components/characters/codegen/PetastiChamiliApostrofos.js';
import { PetastiChamiliElafron } from '../components/characters/codegen/PetastiChamiliElafron.js';
import { PetastiChamiliElafronApostrofos } from '../components/characters/codegen/PetastiChamiliElafronApostrofos.js';
import { PetastiDoubleChamili } from '../components/characters/codegen/PetastiDoubleChamili.js';
import { PetastiDoubleChamiliApostrofos } from '../components/characters/codegen/PetastiDoubleChamiliApostrofos.js';
// import { Kentima } from '../components/characters/codegen/Kentima.js';
import { Kentimata } from '../components/characters/codegen/Kentimata.js';
import { OligonKentimataBelow } from '../components/characters/OligonKentimataBelow.js';
import { OligonKentimataAbove } from '../components/characters/codegen/OligonKentimataAbove.js';
import { OligonIsonKentimata } from '../components/characters/codegen/OligonIsonKentimata.js';
import { OligonKentimaMiddleKentimata } from '../components/characters/codegen/OligonKentimaMiddleKentimata.js';
import { OligonYpsiliRightKentimata } from '../components/characters/codegen/OligonYpsiliRightKentimata.js';
import { OligonYpsiliLeftKentimata } from '../components/characters/codegen/OligonYpsiliLeftKentimata.js';
import { OligonApostrofosKentimata } from '../components/characters/codegen/OligonApostrofosKentimata.js';
import { OligonYporroiKentimata } from '../components/characters/codegen/OligonYporroiKentimata.js';
import { OligonElafronKentimata } from '../components/characters/codegen/OligonElafronKentimata.js';
import { OligonRunningElafronKentimata } from '../components/characters/codegen/OligonRunningElafronKentimata.js';
import { OligonElafronApostrofosKentimata } from '../components/characters/codegen/OligonElafronApostrofosKentimata.js';
import { OligonChamiliKentimata } from '../components/characters/codegen/OligonChamiliKentimata.js';
import { Vareia } from '../components/characters/Vareia.js';
import { Psifiston } from '../components/characters/codegen/Psifiston.js';
import { Antikenoma } from '../components/characters/Antikenoma.js';
import { Omalon } from '../components/characters/codegen/Omalon.js';
import { OmalonConnecting } from '../components/characters/codegen/OmalonConnecting.js';
import { Heteron } from '../components/characters/codegen/Heteron.js';
import { HeteronConnecting } from '../components/characters/codegen/HeteronConnecting.js';
// import { Endofonon } from '../components/characters/codegen/Endofonon.js';
// import { YfenAbove } from '../components/characters/codegen/YfenAbove.js';
// import { YfenBelow } from '../components/characters/codegen/YfenBelow.js';
// import { Stavros } from '../components/characters/codegen/Stavros.js';
// import { Breath } from '../components/characters/codegen/Breath.js';
import { KlasmaAbove } from '../components/characters/codegen/KlasmaAbove.js';
import { KlasmaBelow } from '../components/characters/codegen/KlasmaBelow.js';
// import { Apli } from '../components/characters/codegen/Apli.js';
// import { Dipli } from '../components/characters/codegen/Dipli.js';
// import { Tripli } from '../components/characters/codegen/Tripli.js';
// import { Tetrapli } from '../components/characters/codegen/Tetrapli.js';
// import { Koronis } from '../components/characters/codegen/Koronis.js';
import { Leimma1 } from '../components/characters/codegen/Leimma1.js';
import { Leimma2 } from '../components/characters/codegen/Leimma2.js';
import { Leimma3 } from '../components/characters/codegen/Leimma3.js';
import { Leimma4 } from '../components/characters/codegen/Leimma4.js';
// import { LeimmaDot } from '../components/characters/codegen/LeimmaDot.js';
import { GorgonAbove } from '../components/characters/codegen/GorgonAbove.js';
import { GorgonBelow } from '../components/characters/codegen/GorgonBelow.js';
import { GorgonDottedLeft } from '../components/characters/codegen/GorgonDottedLeft.js';
import { GorgonDottedRight } from '../components/characters/codegen/GorgonDottedRight.js';
import { Digorgon } from '../components/characters/codegen/Digorgon.js';
import { DigorgonDottedLeftBelow } from '../components/characters/codegen/DigorgonDottedLeftBelow.js';
import { DigorgonDottedLeftAbove } from '../components/characters/codegen/DigorgonDottedLeftAbove.js';
import { DigorgonDottedRight } from '../components/characters/codegen/DigorgonDottedRight.js';
import { Trigorgon } from '../components/characters/codegen/Trigorgon.js';
import { TrigorgonDottedLeftBelow } from '../components/characters/codegen/TrigorgonDottedLeftBelow.js';
import { TrigorgonDottedLeftAbove } from '../components/characters/codegen/TrigorgonDottedLeftAbove.js';
import { TrigorgonDottedRight } from '../components/characters/codegen/TrigorgonDottedRight.js';
// import { Argon } from '../components/characters/codegen/Argon.js';
// import { Diargon } from '../components/characters/codegen/Diargon.js';
// import { Triargon } from '../components/characters/codegen/Triargon.js';
import { GorgonSecondary } from '../components/characters/codegen/GorgonSecondary.js';
import { GorgonDottedLeftSecondary } from '../components/characters/codegen/GorgonDottedLeftSecondary.js';
import { GorgonDottedRightSecondary } from '../components/characters/codegen/GorgonDottedRightSecondary.js';
import { DigorgonSecondary } from '../components/characters/codegen/DigorgonSecondary.js';
import { DigorgonDottedLeftBelowSecondary } from '../components/characters/codegen/DigorgonDottedLeftBelowSecondary.js';
import { DigorgonDottedRightSecondary } from '../components/characters/codegen/DigorgonDottedRightSecondary.js';
import { TrigorgonSecondary } from '../components/characters/codegen/TrigorgonSecondary.js';
import { TrigorgonDottedLeftBelowSecondary } from '../components/characters/codegen/TrigorgonDottedLeftBelowSecondary.js';
import { TrigorgonDottedRightSecondary } from '../components/characters/codegen/TrigorgonDottedRightSecondary.js';
import { DigorgonDottedLeftSecondary } from '../components/characters/codegen/DigorgonDottedLeftSecondary.js';
import { TrigorgonDottedLeftSecondary } from '../components/characters/codegen/TrigorgonDottedLeftSecondary.js';
import { AgogiPoliArgi } from '../components/characters/codegen/AgogiPoliArgi.js';
import { AgogiArgoteri } from '../components/characters/codegen/AgogiArgoteri.js';
import { AgogiArgi } from '../components/characters/codegen/AgogiArgi.js';
import { AgogiMetria } from '../components/characters/codegen/AgogiMetria.js';
import { AgogiMesi } from '../components/characters/codegen/AgogiMesi.js';
import { AgogiGorgi } from '../components/characters/codegen/AgogiGorgi.js';
import { AgogiGorgoteri } from '../components/characters/codegen/AgogiGorgoteri.js';
import { AgogiPoliGorgi } from '../components/characters/codegen/AgogiPoliGorgi.js';
import { AgogiPoliArgiAbove } from '../components/characters/codegen/AgogiPoliArgiAbove.js';
import { AgogiArgoteriAbove } from '../components/characters/codegen/AgogiArgoteriAbove.js';
import { AgogiArgiAbove } from '../components/characters/codegen/AgogiArgiAbove.js';
import { AgogiMetriaAbove } from '../components/characters/codegen/AgogiMetriaAbove.js';
import { AgogiMesiAbove } from '../components/characters/codegen/AgogiMesiAbove.js';
import { AgogiGorgiAbove } from '../components/characters/codegen/AgogiGorgiAbove.js';
import { AgogiGorgoteriAbove } from '../components/characters/codegen/AgogiGorgoteriAbove.js';
import { AgogiPoliGorgiAbove } from '../components/characters/codegen/AgogiPoliGorgiAbove.js';
import { MartyriaNoteZoLow } from '../components/characters/codegen/MartyriaNoteZoLow.js';
import { MartyriaNoteNiLow } from '../components/characters/codegen/MartyriaNoteNiLow.js';
import { MartyriaNotePaLow } from '../components/characters/codegen/MartyriaNotePaLow.js';
import { MartyriaNoteVouLow } from '../components/characters/codegen/MartyriaNoteVouLow.js';
import { MartyriaNoteGaLow } from '../components/characters/codegen/MartyriaNoteGaLow.js';
import { MartyriaNoteDiLow } from '../components/characters/codegen/MartyriaNoteDiLow.js';
import { MartyriaNoteKeLow } from '../components/characters/codegen/MartyriaNoteKeLow.js';
import { MartyriaNoteZo } from '../components/characters/codegen/MartyriaNoteZo.js';
import { MartyriaNoteNi } from '../components/characters/codegen/MartyriaNoteNi.js';
import { MartyriaNotePa } from '../components/characters/codegen/MartyriaNotePa.js';
import { MartyriaNoteVou } from '../components/characters/codegen/MartyriaNoteVou.js';
import { MartyriaNoteGa } from '../components/characters/codegen/MartyriaNoteGa.js';
import { MartyriaNoteDi } from '../components/characters/codegen/MartyriaNoteDi.js';
import { MartyriaNoteKe } from '../components/characters/codegen/MartyriaNoteKe.js';
import { MartyriaNoteZoHigh } from '../components/characters/codegen/MartyriaNoteZoHigh.js';
import { MartyriaNoteNiHigh } from '../components/characters/codegen/MartyriaNoteNiHigh.js';
import { MartyriaNotePaHigh } from '../components/characters/codegen/MartyriaNotePaHigh.js';
import { MartyriaNoteVouHigh } from '../components/characters/codegen/MartyriaNoteVouHigh.js';
import { MartyriaNoteGaHigh } from '../components/characters/codegen/MartyriaNoteGaHigh.js';
import { MartyriaNoteDiHigh } from '../components/characters/codegen/MartyriaNoteDiHigh.js';
import { MartyriaNoteKeHigh } from '../components/characters/codegen/MartyriaNoteKeHigh.js';
import { MartyriaTick } from '../components/characters/codegen/MartyriaTick.js';
import { MartyriaZoBelow } from '../components/characters/codegen/MartyriaZoBelow.js';
import { MartyriaDeltaBelow } from '../components/characters/codegen/MartyriaDeltaBelow.js';
import { MartyriaAlphaBelow } from '../components/characters/codegen/MartyriaAlphaBelow.js';
import { MartyriaLegetosBelow } from '../components/characters/codegen/MartyriaLegetosBelow.js';
import { MartyriaNanaBelow } from '../components/characters/codegen/MartyriaNanaBelow.js';
import { MartyriaDeltaDottedBelow } from '../components/characters/codegen/MartyriaDeltaDottedBelow.js';
import { MartyriaAlphaDottedBelow } from '../components/characters/codegen/MartyriaAlphaDottedBelow.js';
import { MartyriaHardChromaticPaBelow } from '../components/characters/codegen/MartyriaHardChromaticPaBelow.js';
import { MartyriaHardChromaticDiBelow } from '../components/characters/codegen/MartyriaHardChromaticDiBelow.js';
import { MartyriaSoftChromaticDiBelow } from '../components/characters/codegen/MartyriaSoftChromaticDiBelow.js';
import { MartyriaSoftChromaticKeBelow } from '../components/characters/codegen/MartyriaSoftChromaticKeBelow.js';
import { MartyriaZygosBelow } from '../components/characters/codegen/MartyriaZygosBelow.js';
import { MartyriaZoAbove } from '../components/characters/codegen/MartyriaZoAbove.js';
import { MartyriaDeltaAbove } from '../components/characters/codegen/MartyriaDeltaAbove.js';
import { MartyriaAlphaAbove } from '../components/characters/codegen/MartyriaAlphaAbove.js';
import { MartyriaLegetosAbove } from '../components/characters/codegen/MartyriaLegetosAbove.js';
import { MartyriaNanaAbove } from '../components/characters/codegen/MartyriaNanaAbove.js';
import { MartyriaDeltaDottedAbove } from '../components/characters/codegen/MartyriaDeltaDottedAbove.js';
import { MartyriaAlphaDottedAbove } from '../components/characters/codegen/MartyriaAlphaDottedAbove.js';
import { MartyriaHardChromaticPaAbove } from '../components/characters/codegen/MartyriaHardChromaticPaAbove.js';
import { MartyriaHardChromaticDiAbove } from '../components/characters/codegen/MartyriaHardChromaticDiAbove.js';
import { MartyriaSoftChromaticDiAbove } from '../components/characters/codegen/MartyriaSoftChromaticDiAbove.js';
import { MartyriaSoftChromaticKeAbove } from '../components/characters/codegen/MartyriaSoftChromaticKeAbove.js';
import { MartyriaZygosAbove } from '../components/characters/codegen/MartyriaZygosAbove.js';
import { FthoraDiatonicNiLowAbove } from '../components/characters/codegen/FthoraDiatonicNiLowAbove.js';
import { FthoraDiatonicPaAbove } from '../components/characters/codegen/FthoraDiatonicPaAbove.js';
import { FthoraDiatonicVouAbove } from '../components/characters/codegen/FthoraDiatonicVouAbove.js';
import { FthoraDiatonicGaAbove } from '../components/characters/codegen/FthoraDiatonicGaAbove.js';
import { FthoraDiatonicDiAbove } from '../components/characters/codegen/FthoraDiatonicDiAbove.js';
import { FthoraDiatonicKeAbove } from '../components/characters/codegen/FthoraDiatonicKeAbove.js';
import { FthoraDiatonicZoAbove } from '../components/characters/codegen/FthoraDiatonicZoAbove.js';
import { FthoraDiatonicNiHighAbove } from '../components/characters/codegen/FthoraDiatonicNiHighAbove.js';
import { FthoraHardChromaticPaAbove } from '../components/characters/codegen/FthoraHardChromaticPaAbove.js';
import { FthoraHardChromaticDiAbove } from '../components/characters/codegen/FthoraHardChromaticDiAbove.js';
import { FthoraSoftChromaticDiAbove } from '../components/characters/codegen/FthoraSoftChromaticDiAbove.js';
import { FthoraSoftChromaticKeAbove } from '../components/characters/codegen/FthoraSoftChromaticKeAbove.js';
import { FthoraEnharmonicAbove } from '../components/characters/codegen/FthoraEnharmonicAbove.js';
import { ChroaZygosAbove } from '../components/characters/codegen/ChroaZygosAbove.js';
import { ChroaKlitonAbove } from '../components/characters/codegen/ChroaKlitonAbove.js';
import { ChroaSpathiAbove } from '../components/characters/codegen/ChroaSpathiAbove.js';
import { FthoraDiatonicNiLowSecondary } from '../components/characters/codegen/FthoraDiatonicNiLowSecondary.js';
import { FthoraDiatonicPaSecondary } from '../components/characters/codegen/FthoraDiatonicPaSecondary.js';
import { FthoraDiatonicVouSecondary } from '../components/characters/codegen/FthoraDiatonicVouSecondary.js';
import { FthoraDiatonicGaSecondary } from '../components/characters/codegen/FthoraDiatonicGaSecondary.js';
import { FthoraDiatonicDiSecondary } from '../components/characters/codegen/FthoraDiatonicDiSecondary.js';
import { FthoraDiatonicKeSecondary } from '../components/characters/codegen/FthoraDiatonicKeSecondary.js';
import { FthoraDiatonicZoSecondary } from '../components/characters/codegen/FthoraDiatonicZoSecondary.js';
import { FthoraDiatonicNiHighSecondary } from '../components/characters/codegen/FthoraDiatonicNiHighSecondary.js';
import { FthoraHardChromaticPaSecondary } from '../components/characters/codegen/FthoraHardChromaticPaSecondary.js';
import { FthoraHardChromaticDiSecondary } from '../components/characters/codegen/FthoraHardChromaticDiSecondary.js';
import { FthoraSoftChromaticDiSecondary } from '../components/characters/codegen/FthoraSoftChromaticDiSecondary.js';
import { FthoraSoftChromaticKeSecondary } from '../components/characters/codegen/FthoraSoftChromaticKeSecondary.js';
import { FthoraEnharmonicSecondary } from '../components/characters/codegen/FthoraEnharmonicSecondary.js';
import { ChroaZygosSecondary } from '../components/characters/codegen/ChroaZygosSecondary.js';
import { ChroaKlitonSecondary } from '../components/characters/codegen/ChroaKlitonSecondary.js';
import { ChroaSpathiSecondary } from '../components/characters/codegen/ChroaSpathiSecondary.js';
import { FthoraDiatonicNiLowTertiary } from '../components/characters/codegen/FthoraDiatonicNiLowTertiary.js';
import { FthoraDiatonicPaTertiary } from '../components/characters/codegen/FthoraDiatonicPaTertiary.js';
import { FthoraDiatonicVouTertiary } from '../components/characters/codegen/FthoraDiatonicVouTertiary.js';
import { FthoraDiatonicGaTertiary } from '../components/characters/codegen/FthoraDiatonicGaTertiary.js';
import { FthoraDiatonicDiTertiary } from '../components/characters/codegen/FthoraDiatonicDiTertiary.js';
import { FthoraDiatonicKeTertiary } from '../components/characters/codegen/FthoraDiatonicKeTertiary.js';
import { FthoraDiatonicZoTertiary } from '../components/characters/codegen/FthoraDiatonicZoTertiary.js';
import { FthoraDiatonicNiHighTertiary } from '../components/characters/codegen/FthoraDiatonicNiHighTertiary.js';
import { FthoraHardChromaticPaTertiary } from '../components/characters/codegen/FthoraHardChromaticPaTertiary.js';
import { FthoraHardChromaticDiTertiary } from '../components/characters/codegen/FthoraHardChromaticDiTertiary.js';
import { FthoraSoftChromaticDiTertiary } from '../components/characters/codegen/FthoraSoftChromaticDiTertiary.js';
import { FthoraSoftChromaticKeTertiary } from '../components/characters/codegen/FthoraSoftChromaticKeTertiary.js';
import { FthoraEnharmonicTertiary } from '../components/characters/codegen/FthoraEnharmonicTertiary.js';
import { ChroaZygosTertiary } from '../components/characters/codegen/ChroaZygosTertiary.js';
import { ChroaKlitonTertiary } from '../components/characters/codegen/ChroaKlitonTertiary.js';
import { ChroaSpathiTertiary } from '../components/characters/codegen/ChroaSpathiTertiary.js';

import { FthoraDiatonicNiLowBelow } from '../components/characters/codegen/FthoraDiatonicNiLowBelow.js';
import { FthoraDiatonicPaBelow } from '../components/characters/codegen/FthoraDiatonicPaBelow.js';
import { FthoraDiatonicVouBelow } from '../components/characters/codegen/FthoraDiatonicVouBelow.js';
import { FthoraDiatonicGaBelow } from '../components/characters/codegen/FthoraDiatonicGaBelow.js';
import { FthoraDiatonicDiBelow } from '../components/characters/codegen/FthoraDiatonicDiBelow.js';
import { FthoraDiatonicKeBelow } from '../components/characters/codegen/FthoraDiatonicKeBelow.js';
import { FthoraDiatonicZoBelow } from '../components/characters/codegen/FthoraDiatonicZoBelow.js';
import { FthoraDiatonicNiHighBelow } from '../components/characters/codegen/FthoraDiatonicNiHighBelow.js';
import { FthoraHardChromaticPaBelow } from '../components/characters/codegen/FthoraHardChromaticPaBelow.js';
import { FthoraHardChromaticDiBelow } from '../components/characters/codegen/FthoraHardChromaticDiBelow.js';
import { FthoraSoftChromaticDiBelow } from '../components/characters/codegen/FthoraSoftChromaticDiBelow.js';
import { FthoraSoftChromaticKeBelow } from '../components/characters/codegen/FthoraSoftChromaticKeBelow.js';
import { FthoraEnharmonicBelow } from '../components/characters/codegen/FthoraEnharmonicBelow.js';
import { ChroaZygosBelow } from '../components/characters/codegen/ChroaZygosBelow.js';
import { ChroaKlitonBelow } from '../components/characters/codegen/ChroaKlitonBelow.js';
import { ChroaSpathiBelow } from '../components/characters/codegen/ChroaSpathiBelow.js';
import { Diesis2 } from '../components/characters/codegen/Diesis2.js';
import { Diesis4 } from '../components/characters/codegen/Diesis4.js';
import { Diesis6 } from '../components/characters/codegen/Diesis6.js';
import { Diesis8 } from '../components/characters/codegen/Diesis8.js';
import { DiesisGenikiAbove } from '../components/characters/codegen/DiesisGenikiAbove.js';
import { DiesisGenikiBelow } from '../components/characters/codegen/DiesisGenikiBelow.js';
import { DiesisGenikiSecondary } from '../components/characters/codegen/DiesisGenikiSecondary.js';
import { DiesisGenikiTertiary } from '../components/characters/codegen/DiesisGenikiTertiary.js';
import { Yfesis2 } from '../components/characters/codegen/Yfesis2.js';
import { Yfesis4 } from '../components/characters/codegen/Yfesis4.js';
import { Yfesis6 } from '../components/characters/codegen/Yfesis6.js';
import { Yfesis8 } from '../components/characters/codegen/Yfesis8.js';
import { YfesisGenikiAbove } from '../components/characters/codegen/YfesisGenikiAbove.js';
import { YfesisGenikiBelow } from '../components/characters/codegen/YfesisGenikiBelow.js';
import { Diesis2Secondary } from '../components/characters/codegen/Diesis2Secondary.js';
import { Diesis4Secondary } from '../components/characters/codegen/Diesis4Secondary.js';
import { Diesis6Secondary } from '../components/characters/codegen/Diesis6Secondary.js';
import { Diesis8Secondary } from '../components/characters/codegen/Diesis8Secondary.js';
import { Diesis2Tertiary } from '../components/characters/codegen/Diesis2Tertiary.js';
import { Diesis4Tertiary } from '../components/characters/codegen/Diesis4Tertiary.js';
import { Diesis6Tertiary } from '../components/characters/codegen/Diesis6Tertiary.js';
import { Diesis8Tertiary } from '../components/characters/codegen/Diesis8Tertiary.js';
import { Yfesis2Secondary } from '../components/characters/codegen/Yfesis2Secondary.js';
import { Yfesis4Secondary } from '../components/characters/codegen/Yfesis4Secondary.js';
import { Yfesis6Secondary } from '../components/characters/codegen/Yfesis6Secondary.js';
import { Yfesis8Secondary } from '../components/characters/codegen/Yfesis8Secondary.js';
import { Yfesis2Tertiary } from '../components/characters/codegen/Yfesis2Tertiary.js';
import { Yfesis4Tertiary } from '../components/characters/codegen/Yfesis4Tertiary.js';
import { Yfesis6Tertiary } from '../components/characters/codegen/Yfesis6Tertiary.js';
import { Yfesis8Tertiary } from '../components/characters/codegen/Yfesis8Tertiary.js';
import { YfesisGenikiSecondary } from '../components/characters/codegen/YfesisGenikiSecondary.js';
import { YfesisGenikiTertiary } from '../components/characters/codegen/YfesisGenikiTertiary.js';
import { BarlineSingle } from '../components/characters/codegen/BarlineSingle.js';
import { BarlineDouble } from '../components/characters/codegen/BarlineDouble.js';
import { BarlineTheseos } from '../components/characters/codegen/BarlineTheseos.js';
import { BarlineShortSingle } from '../components/characters/codegen/BarlineShortSingle.js';
import { BarlineShortDouble } from '../components/characters/codegen/BarlineShortDouble.js';
import { BarlineShortTheseos } from '../components/characters/codegen/BarlineShortTheseos.js';
import { BarlineSingleAbove } from '../components/characters/codegen/BarlineSingleAbove.js';
import { BarlineDoubleAbove } from '../components/characters/codegen/BarlineDoubleAbove.js';
import { BarlineTheseosAbove } from '../components/characters/codegen/BarlineTheseosAbove.js';
import { BarlineShortSingleAbove } from '../components/characters/codegen/BarlineShortSingleAbove.js';
import { BarlineShortDoubleAbove } from '../components/characters/codegen/BarlineShortDoubleAbove.js';
import { BarlineShortTheseosAbove } from '../components/characters/codegen/BarlineShortTheseosAbove.js';
import { MeasureNumber2 } from '../components/characters/codegen/MeasureNumber2.js';
import { MeasureNumber3 } from '../components/characters/codegen/MeasureNumber3.js';
import { MeasureNumber4 } from '../components/characters/codegen/MeasureNumber4.js';
import { MeasureNumber5 } from '../components/characters/codegen/MeasureNumber5.js';
import { MeasureNumber6 } from '../components/characters/codegen/MeasureNumber6.js';
import { MeasureNumber7 } from '../components/characters/codegen/MeasureNumber7.js';
import { MeasureNumber8 } from '../components/characters/codegen/MeasureNumber8.js';
import { NoteIndicatorNi } from '../components/characters/codegen/NoteIndicatorNi.js';
import { NoteIndicatorPa } from '../components/characters/codegen/NoteIndicatorPa.js';
import { NoteIndicatorVou } from '../components/characters/codegen/NoteIndicatorVou.js';
import { NoteIndicatorGa } from '../components/characters/codegen/NoteIndicatorGa.js';
import { NoteIndicatorDi } from '../components/characters/codegen/NoteIndicatorDi.js';
import { NoteIndicatorKe } from '../components/characters/codegen/NoteIndicatorKe.js';
import { NoteIndicatorZo } from '../components/characters/codegen/NoteIndicatorZo.js';
import { IsonIndicatorUnison } from '../components/characters/codegen/IsonIndicatorUnison.js';
import { IsonIndicatorDiLow } from '../components/characters/codegen/IsonIndicatorDiLow.js';
import { IsonIndicatorKeLow } from '../components/characters/codegen/IsonIndicatorKeLow.js';
import { IsonIndicatorZo } from '../components/characters/codegen/IsonIndicatorZo.js';
import { IsonIndicatorNi } from '../components/characters/codegen/IsonIndicatorNi.js';
import { IsonIndicatorPa } from '../components/characters/codegen/IsonIndicatorPa.js';
import { IsonIndicatorVou } from '../components/characters/codegen/IsonIndicatorVou.js';
import { IsonIndicatorGa } from '../components/characters/codegen/IsonIndicatorGa.js';
import { IsonIndicatorDi } from '../components/characters/codegen/IsonIndicatorDi.js';
import { IsonIndicatorKe } from '../components/characters/codegen/IsonIndicatorKe.js';
import { IsonIndicatorZoHigh } from '../components/characters/codegen/IsonIndicatorZoHigh.js';
import { Gorthmikon } from '../components/characters/codegen/Gorthmikon.js';
import { Pelastikon } from '../components/characters/codegen/Pelastikon.js';
// import { ModeFirst } from '../components/characters/codegen/ModeFirst.js';
// import { ModeSecond } from '../components/characters/codegen/ModeSecond.js';
// import { ModeThird } from '../components/characters/codegen/ModeThird.js';
// import { ModeThirdNana } from '../components/characters/codegen/ModeThirdNana.js';
// import { ModeFourth } from '../components/characters/codegen/ModeFourth.js';
// import { ModeLegetos } from '../components/characters/codegen/ModeLegetos.js';
// import { ModePlagalFirst } from '../components/characters/codegen/ModePlagalFirst.js';
// import { ModePlagalSecond } from '../components/characters/codegen/ModePlagalSecond.js';
// import { ModeVarys } from '../components/characters/codegen/ModeVarys.js';
// import { ModeVarys2 } from '../components/characters/codegen/ModeVarys2.js';
// import { ModePlagalFourth } from '../components/characters/codegen/ModePlagalFourth.js';
// import { ModeNi } from '../components/characters/codegen/ModeNi.js';
// import { ModePa } from '../components/characters/codegen/ModePa.js';
// import { ModeVou } from '../components/characters/codegen/ModeVou.js';
// import { ModeGa } from '../components/characters/codegen/ModeGa.js';
// import { ModeDi } from '../components/characters/codegen/ModeDi.js';
// import { ModeKe } from '../components/characters/codegen/ModeKe.js';
// import { ModeZo } from '../components/characters/codegen/ModeZo.js';
// import { ModeOligonKentimaAbove } from '../components/characters/codegen/ModeOligonKentimaAbove.js';
// import { ModeOligonYpsili } from '../components/characters/codegen/ModeOligonYpsili.js';
// import { ModeElafron } from '../components/characters/codegen/ModeElafron.js';
// import { ModeRunningElafron } from '../components/characters/codegen/ModeRunningElafron.js';
// import { ModePlagal } from '../components/characters/codegen/ModePlagal.js';
// import { ModeWordEchos } from '../components/characters/codegen/ModeWordEchos.js';
// import { ModeWordVarys } from '../components/characters/codegen/ModeWordVarys.js';
// import { ModeAlpha } from '../components/characters/codegen/ModeAlpha.js';
// import { ModeBeta } from '../components/characters/codegen/ModeBeta.js';
// import { ModeGamma } from '../components/characters/codegen/ModeGamma.js';
// import { ModeDelta } from '../components/characters/codegen/ModeDelta.js';
// import { ModeAlphaCapital } from '../components/characters/codegen/ModeAlphaCapital.js';
// import { ModeBetaCapital } from '../components/characters/codegen/ModeBetaCapital.js';
// import { ModeGammaCapital } from '../components/characters/codegen/ModeGammaCapital.js';
// import { ModeDeltaCapital } from '../components/characters/codegen/ModeDeltaCapital.js';

export function defineCustomElementsCharactersBodyAliases() {
  customElements.define('x-i', class extends Ison {});
  customElements.define('x-o', class extends Oligon {});
  customElements.define('x-o1', class extends Oligon {});
  customElements.define('x-o2-m', class extends OligonKentimaMiddle {});
  customElements.define('x-o2', class extends OligonKentimaBelow {});
  customElements.define('x-o3', class extends OligonKentimaAbove {});
  customElements.define('x-o4', class extends OligonYpsiliRight {});
  customElements.define('x-o5', class extends OligonYpsiliLeft {});
  customElements.define('x-o6', class extends OligonKentimaYpsiliRight {});
  customElements.define('x-o7', class extends OligonKentimaYpsiliMiddle {});
  customElements.define('x-o8', class extends OligonDoubleYpsili {});
  customElements.define('x-o9', class extends OligonKentimataDoubleYpsili {});
  customElements.define(
    'x-o10',
    class extends OligonKentimaDoubleYpsiliRight {},
  );
  customElements.define(
    'x-o11',
    class extends OligonKentimaDoubleYpsiliLeft {},
  );
  customElements.define('x-o12', class extends OligonTripleYpsili {});
  customElements.define('x-o13', class extends OligonKentimataTripleYpsili {});
  customElements.define('x-o14', class extends OligonKentimaTripleYpsili {});
  customElements.define('x-o-i', class extends OligonIson {});
  customElements.define('x-o-a', class extends OligonApostrofos {});
  customElements.define('x-o-y', class extends OligonYporroi {});
  customElements.define('x-o-e', class extends OligonElafron {});
  customElements.define('x-o-ea', class extends OligonElafronApostrofos {});
  customElements.define('x-o-ch', class extends OligonChamili {});
  customElements.define('x-i-a', class extends IsonApostrofos {});
  customElements.define('x-a', class extends Apostrofos {});
  customElements.define('x-aa', class extends ApostrofosSyndesmos {});
  customElements.define('x-y', class extends Yporroi {});
  customElements.define('x-e', class extends Elafron {});
  customElements.define('x-re', class extends RunningElafron {});
  customElements.define('x-ea', class extends ElafronApostrofos {});
  customElements.define('x-ch', class extends Chamili {});
  customElements.define('x-ch4', class extends Chamili {});
  customElements.define('x-ch5', class extends ChamiliApostrofos {});
  customElements.define('x-ch6', class extends ChamiliElafron {});
  customElements.define('x-ch7', class extends ChamiliElafronApostrofos {});
  customElements.define('x-ch8', class extends DoubleChamili {});
  customElements.define('x-ch9', class extends DoubleChamiliApostrofos {});
  customElements.define('x-ch10', class extends DoubleChamiliElafron {});
  customElements.define(
    'x-ch11',
    class extends DoubleChamiliElafronApostrofos {},
  );
  customElements.define('x-ch12', class extends TripleChamili {});
  customElements.define('x-p0', class extends PetastiIson {});
  customElements.define('x-p-i', class extends PetastiIson {});
  customElements.define('x-p', class extends Petasti {});
  customElements.define('x-p1', class extends Petasti {});
  customElements.define('x-p2', class extends PetastiOligon {});
  customElements.define('x-p3', class extends PetastiKentima {});
  customElements.define('x-p4', class extends PetastiYpsiliRight {});
  customElements.define('x-p5', class extends PetastiYpsiliLeft {});
  customElements.define('x-p6', class extends PetastiKentimaYpsiliRight {});
  customElements.define('x-p7', class extends PetastiKentimaYpsiliMiddle {});
  customElements.define('x-p8', class extends PetastiDoubleYpsili {});
  customElements.define('x-p9', class extends PetastiKentimataDoubleYpsili {});
  customElements.define(
    'x-p10',
    class extends PetastiKentimaDoubleYpsiliRight {},
  );
  customElements.define(
    'x-p11',
    class extends PetastiKentimaDoubleYpsiliLeft {},
  );
  customElements.define('x-p12', class extends PetastiTripleYpsili {});
  customElements.define('x-p13', class extends PetastiKentimataTripleYpsili {});
  customElements.define('x-p14', class extends PetastiKentimaTripleYpsili {});
  customElements.define('x-p-a', class extends PetastiApostrofos {});
  customElements.define('x-p-y', class extends PetastiYporroi {});
  customElements.define('x-p-e', class extends PetastiElafron {});
  customElements.define('x-p-re', class extends PetastiRunningElafron {});
  customElements.define('x-p-ea', class extends PetastiElafronApostrofos {});
  customElements.define('x-p-ch', class extends PetastiChamili {});
  customElements.define('x-p-ch4', class extends PetastiChamili {});
  customElements.define('x-p-ch5', class extends PetastiChamiliApostrofos {});
  customElements.define('x-p-ch6', class extends PetastiChamiliElafron {});
  customElements.define(
    'x-p-ch7',
    class extends PetastiChamiliElafronApostrofos {},
  );
  customElements.define('x-p-ch8', class extends PetastiDoubleChamili {});
  customElements.define(
    'x-p-ch9',
    class extends PetastiDoubleChamiliApostrofos {},
  );
  // customElements.define('x-kentima', class extends Kentima {});
  customElements.define('x-k', class extends Kentimata {});
  customElements.define('x-ko', class extends OligonKentimataBelow {});
  customElements.define('x-ok', class extends OligonKentimataAbove {});
  customElements.define('x-o-i-k', class extends OligonIsonKentimata {});
  customElements.define(
    'x-o2-m-k',
    class extends OligonKentimaMiddleKentimata {},
  );
  customElements.define('x-o4-k', class extends OligonYpsiliRightKentimata {});
  customElements.define('x-o5-k', class extends OligonYpsiliLeftKentimata {});
  customElements.define('x-o-a-k', class extends OligonApostrofosKentimata {});
  customElements.define('x-o-y-k', class extends OligonYporroiKentimata {});
  customElements.define('x-o-e-k', class extends OligonElafronKentimata {});
  customElements.define(
    'x-o-re-k',
    class extends OligonRunningElafronKentimata {},
  );
  customElements.define(
    'x-o-ea-k',
    class extends OligonElafronApostrofosKentimata {},
  );
  customElements.define('x-o-ch-k', class extends OligonChamiliKentimata {});

  customElements.define('x-var', class extends Vareia {});

  // customElements.define('x-stavros', class extends Stavros {});
  // customElements.define('x-breath', class extends Breath {});
  customElements.define('x-l1', class extends Leimma1 {});
  customElements.define('x-l2', class extends Leimma2 {});
  customElements.define('x-l3', class extends Leimma3 {});
  customElements.define('x-l4', class extends Leimma4 {});

  customElements.define('x-t1', class extends AgogiPoliArgi {});
  customElements.define('x-t2', class extends AgogiArgoteri {});
  customElements.define('x-t3', class extends AgogiArgi {});
  customElements.define('x-t4', class extends AgogiMetria {});
  customElements.define('x-t5', class extends AgogiMesi {});
  customElements.define('x-t6', class extends AgogiGorgi {});
  customElements.define('x-t7', class extends AgogiGorgoteri {});
  customElements.define('x-t8', class extends AgogiPoliGorgi {});
  customElements.define('x-m-zo-low', class extends MartyriaNoteZoLow {});
  customElements.define('x-m-ni-low', class extends MartyriaNoteNiLow {});
  customElements.define('x-m-pa-low', class extends MartyriaNotePaLow {});
  customElements.define('x-m-vou-low', class extends MartyriaNoteVouLow {});
  customElements.define('x-m-ga-low', class extends MartyriaNoteGaLow {});
  customElements.define('x-m-di-low', class extends MartyriaNoteDiLow {});
  customElements.define('x-m-ke-low', class extends MartyriaNoteKeLow {});
  customElements.define('x-m-zo', class extends MartyriaNoteZo {});
  customElements.define('x-m-ni', class extends MartyriaNoteNi {});
  customElements.define('x-m-pa', class extends MartyriaNotePa {});
  customElements.define('x-m-vou', class extends MartyriaNoteVou {});
  customElements.define('x-m-ga', class extends MartyriaNoteGa {});
  customElements.define('x-m-di', class extends MartyriaNoteDi {});
  customElements.define('x-m-ke', class extends MartyriaNoteKe {});
  customElements.define('x-m-zo-high', class extends MartyriaNoteZoHigh {});
  customElements.define('x-m-ni-high', class extends MartyriaNoteNiHigh {});
  customElements.define('x-m-pa-high', class extends MartyriaNotePaHigh {});
  customElements.define('x-m-vou-high', class extends MartyriaNoteVouHigh {});
  customElements.define('x-m-ga-high', class extends MartyriaNoteGaHigh {});
  customElements.define('x-m-di-high', class extends MartyriaNoteDiHigh {});
  customElements.define('x-m-ke-high', class extends MartyriaNoteKeHigh {});
  customElements.define('x-bar', class extends BarlineSingle {});
  customElements.define('x-bar2', class extends BarlineDouble {});
  customElements.define('x-bar-th', class extends BarlineTheseos {});
  customElements.define('x-bar-s', class extends BarlineShortSingle {});
  customElements.define('x-bar2-s', class extends BarlineShortDouble {});
  customElements.define('x-bar-th-s', class extends BarlineShortTheseos {});
  customElements.define('x-bar-a', class extends BarlineSingleAbove {});
  customElements.define('x-bar2-a', class extends BarlineDoubleAbove {});
  customElements.define('x-bar-th-a', class extends BarlineTheseosAbove {});
  customElements.define('x-bar-s-a', class extends BarlineShortSingleAbove {});
  customElements.define('x-bar2-s-a', class extends BarlineShortDoubleAbove {});
  customElements.define(
    'x-bar-th-s-a',
    class extends BarlineShortTheseosAbove {},
  );
  customElements.define('x-gor', class extends Gorthmikon {});
  customElements.define('x-pel', class extends Pelastikon {});
  // customElements.define('x-mode-first', class extends ModeFirst {});
  // customElements.define('x-mode-second', class extends ModeSecond {});
  // customElements.define('x-mode-third', class extends ModeThird {});
  // customElements.define('x-mode-third-nana', class extends ModeThirdNana {});
  // customElements.define('x-mode-fourth', class extends ModeFourth {});
  // customElements.define('x-mode-legetos', class extends ModeLegetos {});
  // customElements.define(
  //   'x-mode-plagal-first',
  //   class extends ModePlagalFirst {},
  // );
  // customElements.define(
  //   'x-mode-plagal-second',
  //   class extends ModePlagalSecond {},
  // );
  // customElements.define('x-mode-varys', class extends ModeVarys {});
  // customElements.define('x-mode-varys2', class extends ModeVarys2 {});
  // customElements.define(
  //   'x-mode-plagal-fourth',
  //   class extends ModePlagalFourth {},
  // );
  // customElements.define('x-mode-ni', class extends ModeNi {});
  // customElements.define('x-mode-pa', class extends ModePa {});
  // customElements.define('x-mode-vou', class extends ModeVou {});
  // customElements.define('x-mode-ga', class extends ModeGa {});
  // customElements.define('x-mode-di', class extends ModeDi {});
  // customElements.define('x-mode-ke', class extends ModeKe {});
  // customElements.define('x-mode-zo', class extends ModeZo {});
  // customElements.define(
  //   'x-mode-oligon-kentima-t',
  //   class extends ModeOligonKentimaAbove {},
  // );
  // customElements.define(
  //   'x-mode-oligon-ypsili',
  //   class extends ModeOligonYpsili {},
  // );
  // customElements.define('x-mode-elafron', class extends ModeElafron {});
  // customElements.define(
  //   'x-mode-running-elafron',
  //   class extends ModeRunningElafron {},
  // );
  // customElements.define('x-mode-plagal', class extends ModePlagal {});
  // customElements.define('x-mode-word-echos', class extends ModeWordEchos {});
  // customElements.define('x-mode-word-varys', class extends ModeWordVarys {});
  // customElements.define('x-mode-alpha', class extends ModeAlpha {});
  // customElements.define('x-mode-beta', class extends ModeBeta {});
  // customElements.define('x-mode-gamma', class extends ModeGamma {});
  // customElements.define('x-mode-delta', class extends ModeDelta {});
  // customElements.define(
  //   'x-mode-alpha-capital',
  //   class extends ModeAlphaCapital {},
  // );
  // customElements.define(
  //   'x-mode-beta-capital',
  //   class extends ModeBetaCapital {},
  // );
  // customElements.define(
  //   'x-mode-gamma-capital',
  //   class extends ModeGammaCapital {},
  // );
  // customElements.define(
  //   'x-mode-delta-capital',
  //   class extends ModeDeltaCapital {},
  // );
}

export function defineCustomElementsCharactersMarkAliases() {
  customElements.define('x-psi', class extends Psifiston {});
  customElements.define('x-anti', class extends Antikenoma {});
  customElements.define('x-om', class extends Omalon {});
  customElements.define('x-om-c', class extends OmalonConnecting {});
  customElements.define('x-het', class extends Heteron {});
  customElements.define('x-et', class extends Heteron {});
  customElements.define('x-het-c', class extends HeteronConnecting {});
  customElements.define('x-et-c', class extends HeteronConnecting {});
  // customElements.define('x-endofonon', class extends Endofonon {});
  // customElements.define('x-yfen-t', class extends YfenAbove {});
  // customElements.define('x-yfen-b', class extends YfenBelow {});
  customElements.define('x-kl', class extends KlasmaAbove {});
  customElements.define('x-kl-b', class extends KlasmaBelow {});
  // customElements.define('x-apli', class extends Apli {});
  // customElements.define('x-dipli', class extends Dipli {});
  // customElements.define('x-tripli', class extends Tripli {});
  // customElements.define('x-tetrapli', class extends Tetrapli {});
  // customElements.define('x-koronis', class extends Koronis {});
  // customElements.define('x-leimma-dot', class extends LeimmaDot {});

  customElements.define('x-g', class extends GorgonAbove {});
  customElements.define('x-g-b', class extends GorgonBelow {});
  customElements.define('x-dg', class extends GorgonDottedLeft {});
  customElements.define('x-gd', class extends GorgonDottedRight {});
  customElements.define('x-gg', class extends Digorgon {});
  customElements.define('x-dgg', class extends DigorgonDottedLeftBelow {});
  customElements.define('x-gdg', class extends DigorgonDottedLeftAbove {});
  customElements.define('x-ggd', class extends DigorgonDottedRight {});
  customElements.define('x-ggg', class extends Trigorgon {});
  customElements.define('x-dggg', class extends TrigorgonDottedLeftBelow {});
  customElements.define('x-ggdg', class extends TrigorgonDottedLeftAbove {});
  customElements.define('x-gggd', class extends TrigorgonDottedRight {});
  // customElements.define('x-argon', class extends Argon {});
  // customElements.define('x-diargon', class extends Diargon {});
  // customElements.define('x-triargon', class extends Triargon {});
  customElements.define('x-g-2', class extends GorgonSecondary {});
  customElements.define('x-dg-2', class extends GorgonDottedLeftSecondary {});
  customElements.define('x-gd-2', class extends GorgonDottedRightSecondary {});
  customElements.define('x-gg-2', class extends DigorgonSecondary {});
  customElements.define(
    'x-dgg-2',
    class extends DigorgonDottedLeftBelowSecondary {},
  );
  customElements.define(
    'x-ggd-2',
    class extends DigorgonDottedRightSecondary {},
  );
  customElements.define(
    'x-gdg-2',
    class extends DigorgonDottedLeftSecondary {},
  );
  customElements.define('x-ggg-2', class extends TrigorgonSecondary {});
  customElements.define(
    'x-dggg-2',
    class extends TrigorgonDottedLeftBelowSecondary {},
  );
  customElements.define(
    'x-gggd-2',
    class extends TrigorgonDottedRightSecondary {},
  );
  customElements.define(
    'x-ggdg-2',
    class extends TrigorgonDottedLeftSecondary {},
  );

  customElements.define('x-t1-m', class extends AgogiPoliArgiAbove {});
  customElements.define('x-t2-m', class extends AgogiArgoteriAbove {});
  customElements.define('x-t3-m', class extends AgogiArgiAbove {});
  customElements.define('x-t4-m', class extends AgogiMetriaAbove {});
  customElements.define('x-t5-m', class extends AgogiMesiAbove {});
  customElements.define('x-t6-m', class extends AgogiGorgiAbove {});
  customElements.define('x-t7-m', class extends AgogiGorgoteriAbove {});
  customElements.define('x-t8-m', class extends AgogiPoliGorgiAbove {});
  customElements.define('x-m-tick', class extends MartyriaTick {});
  customElements.define('x-m-varys', class extends MartyriaZoBelow {});
  customElements.define('x-m-delta', class extends MartyriaDeltaBelow {});
  customElements.define('x-m-alpha', class extends MartyriaAlphaBelow {});
  customElements.define('x-m-legetos', class extends MartyriaLegetosBelow {});
  customElements.define('x-m-nana', class extends MartyriaNanaBelow {});
  customElements.define(
    'x-m-delta-aa',
    class extends MartyriaDeltaDottedBelow {},
  );
  customElements.define(
    'x-m-alpha-aa',
    class extends MartyriaAlphaDottedBelow {},
  );
  customElements.define(
    'x-m-hc-pa',
    class extends MartyriaHardChromaticPaBelow {},
  );
  customElements.define(
    'x-m-hc-di',
    class extends MartyriaHardChromaticDiBelow {},
  );
  customElements.define(
    'x-m-sc-di',
    class extends MartyriaSoftChromaticDiBelow {},
  );
  customElements.define(
    'x-m-sc-ke',
    class extends MartyriaSoftChromaticKeBelow {},
  );
  customElements.define('x-m-zygos', class extends MartyriaZygosBelow {});
  customElements.define('x-m-varys-a', class extends MartyriaZoAbove {});
  customElements.define('x-m-delta-a', class extends MartyriaDeltaAbove {});
  customElements.define('x-m-alpha-a', class extends MartyriaAlphaAbove {});
  customElements.define('x-m-legetos-a', class extends MartyriaLegetosAbove {});
  customElements.define('x-m-nana-a', class extends MartyriaNanaAbove {});
  customElements.define(
    'x-m-delta-aa-a',
    class extends MartyriaDeltaDottedAbove {},
  );
  customElements.define(
    'x-m-alpha-aa-a',
    class extends MartyriaAlphaDottedAbove {},
  );
  customElements.define(
    'x-m-hc-pa-a',
    class extends MartyriaHardChromaticPaAbove {},
  );
  customElements.define(
    'x-m-hc-di-a',
    class extends MartyriaHardChromaticDiAbove {},
  );
  customElements.define(
    'x-m-sc-di-a',
    class extends MartyriaSoftChromaticDiAbove {},
  );
  customElements.define(
    'x-m-sc-ke-a',
    class extends MartyriaSoftChromaticKeAbove {},
  );
  customElements.define('x-m-zygos-a', class extends MartyriaZygosAbove {});
  customElements.define(
    'x-f-d-ni-low',
    class extends FthoraDiatonicNiLowAbove {},
  );
  customElements.define('x-f-d-pa', class extends FthoraDiatonicPaAbove {});
  customElements.define('x-f-d-vou', class extends FthoraDiatonicVouAbove {});
  customElements.define('x-f-d-ga', class extends FthoraDiatonicGaAbove {});
  customElements.define('x-f-d-di', class extends FthoraDiatonicDiAbove {});
  customElements.define('x-f-d-ke', class extends FthoraDiatonicKeAbove {});
  customElements.define('x-f-d-zo', class extends FthoraDiatonicZoAbove {});
  customElements.define(
    'x-f-d-ni-high',
    class extends FthoraDiatonicNiHighAbove {},
  );
  customElements.define(
    'x-f-hc-pa',
    class extends FthoraHardChromaticPaAbove {},
  );
  customElements.define(
    'x-f-hc-di',
    class extends FthoraHardChromaticDiAbove {},
  );
  customElements.define(
    'x-f-sc-di',
    class extends FthoraSoftChromaticDiAbove {},
  );
  customElements.define(
    'x-f-sc-ke',
    class extends FthoraSoftChromaticKeAbove {},
  );
  customElements.define('x-f-agem', class extends FthoraEnharmonicAbove {});
  customElements.define('x-f-en', class extends FthoraEnharmonicAbove {});
  customElements.define('x-f-zygos', class extends ChroaZygosAbove {});
  customElements.define('x-f-kliton', class extends ChroaKlitonAbove {});
  customElements.define('x-f-spathi', class extends ChroaSpathiAbove {});
  customElements.define(
    'x-f-d-ni-low-2',
    class extends FthoraDiatonicNiLowSecondary {},
  );
  customElements.define(
    'x-f-d-pa-2',
    class extends FthoraDiatonicPaSecondary {},
  );
  customElements.define(
    'x-f-d-vou-2',
    class extends FthoraDiatonicVouSecondary {},
  );
  customElements.define(
    'x-f-d-ga-2',
    class extends FthoraDiatonicGaSecondary {},
  );
  customElements.define(
    'x-f-d-di-2',
    class extends FthoraDiatonicDiSecondary {},
  );
  customElements.define(
    'x-f-d-ke-2',
    class extends FthoraDiatonicKeSecondary {},
  );
  customElements.define(
    'x-f-d-zo-2',
    class extends FthoraDiatonicZoSecondary {},
  );
  customElements.define(
    'x-f-d-ni-high-2',
    class extends FthoraDiatonicNiHighSecondary {},
  );
  customElements.define(
    'x-f-hc-pa-2',
    class extends FthoraHardChromaticPaSecondary {},
  );
  customElements.define(
    'x-f-hc-di-2',
    class extends FthoraHardChromaticDiSecondary {},
  );
  customElements.define(
    'x-f-sc-di-2',
    class extends FthoraSoftChromaticDiSecondary {},
  );
  customElements.define(
    'x-f-sc-ke-2',
    class extends FthoraSoftChromaticKeSecondary {},
  );
  customElements.define(
    'x-f-agem-2',
    class extends FthoraEnharmonicSecondary {},
  );
  customElements.define('x-f-en-2', class extends FthoraEnharmonicSecondary {});
  customElements.define('x-f-zygos-2', class extends ChroaZygosSecondary {});
  customElements.define('x-f-kliton-2', class extends ChroaKlitonSecondary {});
  customElements.define('x-f-spathi-2', class extends ChroaSpathiSecondary {});

  customElements.define(
    'x-f-d-ni-low-3',
    class extends FthoraDiatonicNiLowTertiary {},
  );
  customElements.define(
    'x-f-d-pa-3',
    class extends FthoraDiatonicPaTertiary {},
  );
  customElements.define(
    'x-f-d-vou-3',
    class extends FthoraDiatonicVouTertiary {},
  );
  customElements.define(
    'x-f-d-ga-3',
    class extends FthoraDiatonicGaTertiary {},
  );
  customElements.define(
    'x-f-d-di-3',
    class extends FthoraDiatonicDiTertiary {},
  );
  customElements.define(
    'x-f-d-ke-3',
    class extends FthoraDiatonicKeTertiary {},
  );
  customElements.define(
    'x-f-d-zo-3',
    class extends FthoraDiatonicZoTertiary {},
  );
  customElements.define(
    'x-f-d-ni-high-3',
    class extends FthoraDiatonicNiHighTertiary {},
  );
  customElements.define(
    'x-f-hc-pa-3',
    class extends FthoraHardChromaticPaTertiary {},
  );
  customElements.define(
    'x-f-hc-di-3',
    class extends FthoraHardChromaticDiTertiary {},
  );
  customElements.define(
    'x-f-sc-di-3',
    class extends FthoraSoftChromaticDiTertiary {},
  );
  customElements.define(
    'x-f-sc-ke-3',
    class extends FthoraSoftChromaticKeTertiary {},
  );
  customElements.define(
    'x-f-agem-3',
    class extends FthoraEnharmonicTertiary {},
  );
  customElements.define('x-f-en-3', class extends FthoraEnharmonicTertiary {});
  customElements.define('x-f-zygos-3', class extends ChroaZygosTertiary {});
  customElements.define('x-f-kliton-3', class extends ChroaKlitonTertiary {});
  customElements.define('x-f-spathi-3', class extends ChroaSpathiTertiary {});

  customElements.define(
    'x-f-d-ni-low-b',
    class extends FthoraDiatonicNiLowBelow {},
  );
  customElements.define('x-f-d-pa-b', class extends FthoraDiatonicPaBelow {});
  customElements.define('x-f-d-vou-b', class extends FthoraDiatonicVouBelow {});
  customElements.define('x-f-d-ga-b', class extends FthoraDiatonicGaBelow {});
  customElements.define('x-f-d-di-b', class extends FthoraDiatonicDiBelow {});
  customElements.define('x-f-d-ke-b', class extends FthoraDiatonicKeBelow {});
  customElements.define('x-f-d-zo-b', class extends FthoraDiatonicZoBelow {});
  customElements.define(
    'x-f-d-ni-high-b',
    class extends FthoraDiatonicNiHighBelow {},
  );
  customElements.define(
    'x-f-hc-pa-b',
    class extends FthoraHardChromaticPaBelow {},
  );
  customElements.define(
    'x-f-hc-di-b',
    class extends FthoraHardChromaticDiBelow {},
  );
  customElements.define(
    'x-f-sc-di-b',
    class extends FthoraSoftChromaticDiBelow {},
  );
  customElements.define(
    'x-f-sc-ke-b',
    class extends FthoraSoftChromaticKeBelow {},
  );
  customElements.define('x-f-en-b', class extends FthoraEnharmonicBelow {});
  customElements.define('x-f-agem-b', class extends FthoraEnharmonicBelow {});
  customElements.define('x-f-zygos-b', class extends ChroaZygosBelow {});
  customElements.define('x-f-kliton-b', class extends ChroaKlitonBelow {});
  customElements.define('x-f-spathi-b', class extends ChroaSpathiBelow {});
  customElements.define('x-di2', class extends Diesis2 {});
  customElements.define('x-di4', class extends Diesis4 {});
  customElements.define('x-di6', class extends Diesis6 {});
  customElements.define('x-di8', class extends Diesis8 {});
  customElements.define('x-di-g', class extends DiesisGenikiAbove {});
  customElements.define('x-di-g-2', class extends DiesisGenikiSecondary {});
  customElements.define('x-di-g-3', class extends DiesisGenikiTertiary {});
  customElements.define('x-di-g-b', class extends DiesisGenikiBelow {});
  customElements.define('x-yf2', class extends Yfesis2 {});
  customElements.define('x-yf4', class extends Yfesis4 {});
  customElements.define('x-yf6', class extends Yfesis6 {});
  customElements.define('x-yf8', class extends Yfesis8 {});
  customElements.define('x-yf-g', class extends YfesisGenikiAbove {});
  customElements.define('x-yf-g-b', class extends YfesisGenikiBelow {});
  customElements.define('x-yf2-2', class extends Yfesis2Secondary {});
  customElements.define('x-yf4-2', class extends Yfesis4Secondary {});
  customElements.define('x-yf6-2', class extends Yfesis6Secondary {});
  customElements.define('x-yf8-2', class extends Yfesis8Secondary {});
  customElements.define('x-yf-g-2', class extends YfesisGenikiSecondary {});
  customElements.define('x-yf2-3', class extends Yfesis2Tertiary {});
  customElements.define('x-yf4-3', class extends Yfesis4Tertiary {});
  customElements.define('x-yf6-3', class extends Yfesis6Tertiary {});
  customElements.define('x-yf8-3', class extends Yfesis8Tertiary {});
  customElements.define('x-yf-g-3', class extends YfesisGenikiTertiary {});
  customElements.define('x-sharp-2', class extends Diesis2 {});
  customElements.define('x-sharp-4', class extends Diesis4 {});
  customElements.define('x-sharp-6', class extends Diesis6 {});
  customElements.define('x-sharp-8', class extends Diesis8 {});
  customElements.define('x-sharp-g', class extends DiesisGenikiAbove {});
  customElements.define('x-sharp-g-2', class extends DiesisGenikiSecondary {});
  customElements.define('x-sharp-g-3', class extends DiesisGenikiTertiary {});
  customElements.define('x-sharp-g-b', class extends DiesisGenikiBelow {});
  customElements.define('x-di2-2', class extends Diesis2Secondary {});
  customElements.define('x-di4-2', class extends Diesis4Secondary {});
  customElements.define('x-di6-2', class extends Diesis6Secondary {});
  customElements.define('x-di8-2', class extends Diesis8Secondary {});
  customElements.define('x-di2-3', class extends Diesis2Tertiary {});
  customElements.define('x-di4-3', class extends Diesis4Tertiary {});
  customElements.define('x-di6-3', class extends Diesis6Tertiary {});
  customElements.define('x-di8-3', class extends Diesis8Tertiary {});
  customElements.define('x-sharp-2-2', class extends Diesis2Secondary {});
  customElements.define('x-sharp-4-2', class extends Diesis4Secondary {});
  customElements.define('x-sharp-6-2', class extends Diesis6Secondary {});
  customElements.define('x-sharp-8-2', class extends Diesis8Secondary {});
  customElements.define('x-sharp-2-3', class extends Diesis2Tertiary {});
  customElements.define('x-sharp-4-3', class extends Diesis4Tertiary {});
  customElements.define('x-sharp-6-3', class extends Diesis6Tertiary {});
  customElements.define('x-sharp-8-3', class extends Diesis8Tertiary {});
  customElements.define('x-flat-2', class extends Yfesis2 {});
  customElements.define('x-flat-4', class extends Yfesis4 {});
  customElements.define('x-flat-6', class extends Yfesis6 {});
  customElements.define('x-flat-8', class extends Yfesis8 {});
  customElements.define('x-flat-2-2', class extends Yfesis2Secondary {});
  customElements.define('x-flat-4-2', class extends Yfesis4Secondary {});
  customElements.define('x-flat-6-2', class extends Yfesis6Secondary {});
  customElements.define('x-flat-8-2', class extends Yfesis8Secondary {});
  customElements.define('x-flat-2-3', class extends Yfesis2Tertiary {});
  customElements.define('x-flat-4-3', class extends Yfesis4Tertiary {});
  customElements.define('x-flat-6-3', class extends Yfesis6Tertiary {});
  customElements.define('x-flat-8-3', class extends Yfesis8Tertiary {});
  customElements.define('x-flat-g', class extends YfesisGenikiAbove {});
  customElements.define('x-flat-g-2', class extends YfesisGenikiSecondary {});
  customElements.define('x-flat-g-3', class extends YfesisGenikiTertiary {});
  customElements.define('x-flat-g-b', class extends YfesisGenikiBelow {});
  customElements.define('x-mn2', class extends MeasureNumber2 {});
  customElements.define('x-mn3', class extends MeasureNumber3 {});
  customElements.define('x-mn4', class extends MeasureNumber4 {});
  customElements.define('x-mn5', class extends MeasureNumber5 {});
  customElements.define('x-mn6', class extends MeasureNumber6 {});
  customElements.define('x-mn7', class extends MeasureNumber7 {});
  customElements.define('x-mn8', class extends MeasureNumber8 {});
  customElements.define('x-ni-ni', class extends NoteIndicatorNi {});
  customElements.define('x-ni-pa', class extends NoteIndicatorPa {});
  customElements.define('x-ni-vou', class extends NoteIndicatorVou {});
  customElements.define('x-ni-ga', class extends NoteIndicatorGa {});
  customElements.define('x-ni-di', class extends NoteIndicatorDi {});
  customElements.define('x-ni-ke', class extends NoteIndicatorKe {});
  customElements.define('x-ni-zo', class extends NoteIndicatorZo {});
  customElements.define('x-ii-uni', class extends IsonIndicatorUnison {});
  customElements.define('x-ii-di-low', class extends IsonIndicatorDiLow {});
  customElements.define('x-ii-ke-low', class extends IsonIndicatorKeLow {});
  customElements.define('x-ii-zo', class extends IsonIndicatorZo {});
  customElements.define('x-ii-ni', class extends IsonIndicatorNi {});
  customElements.define('x-ii-pa', class extends IsonIndicatorPa {});
  customElements.define('x-ii-vou', class extends IsonIndicatorVou {});
  customElements.define('x-ii-ga', class extends IsonIndicatorGa {});
  customElements.define('x-ii-di', class extends IsonIndicatorDi {});
  customElements.define('x-ii-ke', class extends IsonIndicatorKe {});
  customElements.define('x-ii-zo-high', class extends IsonIndicatorZoHigh {});
}
